/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Timeline_Title_AccentInputs */

const en_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videos`)
};

const es_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vídeos`)
};

const de_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos durchstöbern`)
};

const zh_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频`)
};

const ar_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقاطع الفيديو`)
};

const fr_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vidéos`)
};

const vi_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video`)
};

const sw_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video`)
};

const th_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิดีโอ`)
};

const bs_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videozapise`)
};

const ja_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画を見る`)
};

const ko_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영상 둘러보기`)
};

const pt_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vídeos`)
};

const it_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video`)
};

const sv_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videor`)
};

const nl_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video's`)
};

const da_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videoer`)
};

const nb_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videoer`)
};

const fi_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videoita`)
};

const pl_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`filmy`)
};

const ru_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`видео`)
};

const tr_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videolara göz atın`)
};

const hi_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो देखें`)
};

const id_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video`)
};

const ms_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video`)
};

const cs_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videa`)
};

const el_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`βίντεο`)
};

const he_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ובסרטונים`)
};

const af_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`video's`)
};

const hu_hof_timeline_title_accent = /** @type {(inputs: Hof_Timeline_Title_AccentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`videók között`)
};

/**
* | output |
* | --- |
* | "videos" |
*
* @param {Hof_Timeline_Title_AccentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_timeline_title_accent = /** @type {((inputs?: Hof_Timeline_Title_AccentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Timeline_Title_AccentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_timeline_title_accent(inputs)
	if (locale === "de") return de_hof_timeline_title_accent(inputs)
	if (locale === "zh") return zh_hof_timeline_title_accent(inputs)
	if (locale === "ar") return ar_hof_timeline_title_accent(inputs)
	if (locale === "fr") return fr_hof_timeline_title_accent(inputs)
	if (locale === "vi") return vi_hof_timeline_title_accent(inputs)
	if (locale === "sw") return sw_hof_timeline_title_accent(inputs)
	if (locale === "th") return th_hof_timeline_title_accent(inputs)
	if (locale === "bs") return bs_hof_timeline_title_accent(inputs)
	if (locale === "ja") return ja_hof_timeline_title_accent(inputs)
	if (locale === "ko") return ko_hof_timeline_title_accent(inputs)
	if (locale === "pt") return pt_hof_timeline_title_accent(inputs)
	if (locale === "it") return it_hof_timeline_title_accent(inputs)
	if (locale === "sv") return sv_hof_timeline_title_accent(inputs)
	if (locale === "nl") return nl_hof_timeline_title_accent(inputs)
	if (locale === "da") return da_hof_timeline_title_accent(inputs)
	if (locale === "nb") return nb_hof_timeline_title_accent(inputs)
	if (locale === "fi") return fi_hof_timeline_title_accent(inputs)
	if (locale === "pl") return pl_hof_timeline_title_accent(inputs)
	if (locale === "ru") return ru_hof_timeline_title_accent(inputs)
	if (locale === "tr") return tr_hof_timeline_title_accent(inputs)
	if (locale === "hi") return hi_hof_timeline_title_accent(inputs)
	if (locale === "id") return id_hof_timeline_title_accent(inputs)
	if (locale === "ms") return ms_hof_timeline_title_accent(inputs)
	if (locale === "cs") return cs_hof_timeline_title_accent(inputs)
	if (locale === "el") return el_hof_timeline_title_accent(inputs)
	if (locale === "he") return he_hof_timeline_title_accent(inputs)
	if (locale === "af") return af_hof_timeline_title_accent(inputs)
	if (locale === "hu") return hu_hof_timeline_title_accent(inputs)
	return en_hof_timeline_title_accent(inputs)
});